import { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import { Outlet, useLocation } from 'react-router-dom';

const Layout: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        // Scroll to hash element if present in URL
        if (location.hash) {
            const id = location.hash.substring(1);
            const element = document.getElementById(id);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 100);
            }
        }
    }, [location]);

    const hasOwnFooter = location.pathname === '/contact';

    return (
        <div>
            <Header />
            <main>
                <Outlet />
            </main>
            {!hasOwnFooter && <Footer />}
        </div>
    );
};

export default Layout;
